import _ from 'lodash'
import { ActionTree } from 'vuex'

import { ListWithPagination } from '@/models/api/response/list'
import { OrderHistoryApiService } from '../../../services/api/orderHistory'
import { OrderHistoryService } from '../../../services/orderHistory'
import { RootState } from '../../types'
import { getPage } from './functions/page'
import { convertToOrder, convertToOrders, convertToProducts, OrderHistoryState, Page } from './types'

import { log } from '../../../log'

export const actions: ActionTree<OrderHistoryState, RootState> = {

  async addPage({ commit, state }, payload: {
    force?: boolean,
    pageNumber: number,
  }) {
    const { force, pageNumber } = payload

    const existingPage = getPage(state.pages, pageNumber)

    if (!force && existingPage) {
      return  // Skip
    }

    const { perPage } = state
    const orderHistoryApiService = new OrderHistoryApiService()
    const orderHistoryService = new OrderHistoryService()

    /* Call API to list order histories */
    const result = (await orderHistoryApiService.list({
      start: (pageNumber - 1) * perPage,
      limit: perPage,
    }))

    if (result.isLeft()) {
      const error = result.value
      log.error(error)
      commit('addErrorPage', { pageNumber, error })

      return
    }

    /* Map to models with incomplete data */
    const listWithPagination = ListWithPagination.createFrom(result.value)
    const orders = convertToOrders(listWithPagination.list)

    /* Inject additional data to the models */
    const promises = orders.map(async (order) => {
      const rawOrder = _.find(result.value.body.data, ['id', order.id])
      const joined = await orderHistoryApiService.join(rawOrder.item)
      const products = convertToProducts(rawOrder.item)

      order.products = await orderHistoryService.injectWithJoinedProductInfo(products, joined)
    })

    /**
     * TODO:
     * 注文データごとに個別にエラーを補足できず、改善の余地がある
     *
     * @see https://github.com/my-color/front/pull/6936#discussion_r991870935
     */
    try {
      await Promise.all(promises)
    } catch (error) {
      log.error(error)
      commit('addErrorPage', { pageNumber, error })

      return
    }

    /* Add a page */
    const page: Page = {
      pageNumber,
      items: orders,
      isLastPage: listWithPagination.pagination.isLastPage,
    }

    commit('addPage', { page })
  },

  /**
   * :warning:
   * この関数を修正する場合、gettersのgetLatestにも同じ修正を行うこと
   */
  async get({ commit }, id: string) {
    const orderHistoryApiService = new OrderHistoryApiService()
    const result = (await orderHistoryApiService.get(id))

    if (result.isLeft()) {
      const error = result.value
      log.error(error)

      commit('errorOnLoad', {
        load: error,
      })

      return
    }

    const order = convertToOrder(result.value.body.data)

    try {
      const rawOrder = result.value.body.data

      // TODO: Refactoring
      const joined = await orderHistoryApiService.join(rawOrder.item)

      const products = convertToProducts(rawOrder.item)

      order.products = await new OrderHistoryService().injectWithJoinedProductInfo(products, joined)

      order.isFreeShippingOnCatalogOnly = _.every(order.products, 'isCatalogType')

    } catch (error) {
      log.error(error)
      commit('errorOnJoin', {
        id: order.id,
        error,
      })
    }

    commit('get', { order })
  },
}
